import DealerUserAddForm from '../dealer-users/components/DealerUserAddForm';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { dealerUserService } from '../dealer-users/dealerUserService';
import PropTypes from 'prop-types';
import { Spinner } from '@ami/react/core';

class DealerUserAddPageComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submitting: false,
      canceling: false,
      loading: true,
    };
    this.onDealerUserChanged = this.onDealerUserChanged.bind(this);
    this.save = this.save.bind(this);
    this.navigateBack = this.navigateBack.bind(this);
  }

  static defaultProps = {
    enabledRemoveDealerGroup: true,
    enabledAddDealerGroup: true,
  };

  static propTypes = {
    dealerUser: PropTypes.object.isRequired,
    saveFunc: PropTypes.func.isRequired,
    handleDealerUserChanged: PropTypes.func.isRequired,
    enabledRemoveDealerGroup: PropTypes.bool,
    enabledAddDealerGroup: PropTypes.bool,
  };

  async componentDidMount() {
    const permissions = await dealerUserService.getAllPermissions();
    const availableEmailTemplateTypes =
      await dealerUserService.getAvailableEmailTemplateTypes();

    this.props.dealerUser.enabledEmailTemplateTypes =
      availableEmailTemplateTypes.map((x) => x.type);

    const state = {
      permissions,
      availableEmailTemplateTypes,
      loading: false,
    };
    this.setState(state);
  }

  save() {
    this.setState({ submitting: true });
    this.props
      .saveFunc()
      .then(this.navigateBack)
      .catch(() => this.setState({ submitting: false }));
  }

  navigateBack = () => {
    this.setState({ canceling: true }, () => {
      this.props.history.push('/dealer-users');
    });
  };

  async onDealerUserChanged(dealerUser) {
    this.props.handleDealerUserChanged(dealerUser);
  }

  render() {
    const {
      permissions,
      availableEmailTemplateTypes,
      submitting,
      canceling,
      loading,
    } = this.state;

    const { dealerUser, enabledRemoveDealerGroup, enabledAddDealerGroup } =
      this.props;

    if (loading) {
      return (
        <div className="container text-center mt-5 mb-5">
          <h4 className="mt-5 mb-2">Loading</h4>
          <Spinner show={true} size="fa-3x" />
        </div>
      );
    }

    return (
      <DealerUserAddForm
        areThereAnyChanges={!submitting && !canceling}
        dealerUser={dealerUser}
        permissions={permissions}
        availableEmailTemplateTypes={availableEmailTemplateTypes}
        onSubmit={this.save}
        onCancel={this.navigateBack}
        dealerUserChanged={this.onDealerUserChanged}
        submitting={submitting}
        enabledRemoveDealerGroup={enabledRemoveDealerGroup}
        enabledAddDealerGroup={enabledAddDealerGroup}
      />
    );
  }
}

const DealerUserAddPage = withRouter(DealerUserAddPageComponent);
export { DealerUserAddPage };
